import React from "react";
import { Link } from "react-router-dom";
import SearchBar from "./SearchBar";

export default function HeaderBar({ onSearch }) {
  return (
    <header className="h-16 bg-white shadow-sm fixed top-0 left-0 right-0 z-50 flex items-center">
      <div className="flex-none pl-4">
        <Link to="/" className="text-xl font-serif text-taupe-dark">
          Acta Diurna
        </Link>
      </div>
      
      <div className="flex-1 ml-60 pl-4 max-w-xl">
        <SearchBar onSearch={onSearch} />
      </div>
      
      <div className="flex-1">
        {/* Placeholder for future header elements */}
      </div>
    </header>
  );
}